// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface AccountInquiryModal {
    entityStartDate?: {
        date?: string;
    };
    asOfDate?: {
        date?: string;
    };
    future?: string;
    current?: string;
    thirty?: string;
    sixty?: string;
    ninety?: string;
    oneTwenty?: string;
    arTotal?: string;
    arDeposits?: string;
    arOrders?: string;
    mtdSales?: string;
    ytdSales?: string;
    sixMonthAverage?: string;
    sixMonthHigh?: string;
    paymentDays?: string;
    arTerms?: string;
    arCreditLimit?: string;
    arCreditAvail?: string;
    lastSale?: {
        amount?: string;
        date?: string;
    };
    lastPayment?: {
        amount?: string;
        date?: string;
    };
}

export interface AccountInquiryState {
    isLoading: boolean;
    dataViews: AccountInquiryModal;
    failedMessage?: string;
}

const initialState: AccountInquiryState = {
    isLoading: false,
    dataViews: {},
    failedMessage: "",
};

const reducer = {
    "xAccountInquiry/BeginLoadAccountInquiry": (draft: Draft<AccountInquiryState>, action: {}) => {
        draft.isLoading = true;
        draft.failedMessage = "";
    },
    "xAccountInquiry/FailedToLoadAccountInquiry": (
        draft: Draft<AccountInquiryState>,
        action: { failedMessage: string },
    ) => {
        draft.isLoading = false;
        draft.failedMessage = action.failedMessage;
    },
    "xAccountInquiry/CompleteLoadAccountInquiry": (
        draft: Draft<AccountInquiryState>,
        action: { data: AccountInquiryModal },
    ) => {
        draft.isLoading = false;
        draft.dataViews = action.data;
        draft.failedMessage = "";
    },
};

const xAccountInquiry = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).xAccountInquiry = xAccountInquiry;

export type xAccountInquiryState = {
    xAccountInquiry: AccountInquiryState;
} & ApplicationState;
